export default __webpack_public_path__ + "5300f0b568203dc0f94e0122d8112eac.png";